export const Constants = {
    ENVIRONMENT_QA: 'QA',
    ENVIRONMENT_PROD: 'PROD',
    MANAGER_TOOL_TITLE_QA: '(QA) Manager Tool',
    MANAGER_TOOL_TITLE_PROD: 'Manager Tool',
    MANAGER_TOOL_TITLE_DEV: '(DEV) Manager Tool',
    YES: 'Yes',
    NO: 'No',
    FRENCH_NO: 'Non',
    FRENCH_YES: 'Oui',
    YES_NO: 'YES_NO',
    IF_YES_DESCRIBE: 'ifYesDescribe',
    YES_NO_NA: 'YES_NO_NA',
    CONNECTION_TYPE: 'CONNECTION_TYPE',
    SIEMENS_OTHER: 'SIEMENS_OTHER',
    DISCIPLINE_TYPE: 'DISCIPLINE_TYPE',
    CUSTOMER_TYPE: 'CUSTOMER_TYPE',
    AGREEMENT_SUB_TYPE: 'AGREEMENT_SUB_TYPE',
    AGREEMENT_TYPE: 'AGREEMENT_TYPE',
    ENSURE_COSTS_ARE_INCLUDED_TO_COVER_POINT_NAMING: 'Ensure costs are included to cover point naming.',
    ADDITIONAL_LABOR_AND_MATERIAL_REQUIRED: 'Additional labor and material required.',
    COIL_CLEANING_INCLUDED: 'COIL_CLEANING_INCLUDED',
    CUSTOMER_REPORTING_REQUIRED: 'CUSTOMER_REPORTING_REQUIRED',
    CLARITY_OF_SCOPE : 'CLARITY_OF_SCOPE',
    BUSINESS : 'Business',
    REVIEW_OBJECT : 'ReviewObject',
    OPERATOR_WORKSTATION : 'Operator Workstation',
    OPERATOR_WORKSTATION_FIRE : 'Operator Workstation (Desigo CC)', //MS12
    OPERATOR_WORKSTATION_AND_SOFTWARE : 'Operator Workstation and Software',
    CONDUIT_TYPE : 'CONDUIT_TYPE',
    ELECTRICAL_WIRING_CONTROL : 'Electrical Wiring (Controls)',
    ELECTRICAL_WIRING : 'Electrical Wiring',
    PROJECT_MEETINGS_FREQUENCY_FIRE : 'Project meetings frequency',
    PROJECT_MEETINGS_FREQUENCY_AUTOMATION : 'Frequency of project meetings',
    DOOR_HARDWARE_TYPE : 'DOOR_HARDWARE_TYPE', //M4
    SIEMENS_SUBCONTRACTOR_OTHER : 'SIEMENS_SUBCONTRACTOR_OTHER', //M4
    INTEGRATION_REQUIRED : 'INTEGRATION_REQUIRED', //M4
    HARDWIRED_INTEGRATED : 'HARDWIRED_INTEGRATED',
    HARDWIRED_SOFTWARE : 'HARDWIRED_SOFTWARE',  //M2
    HARDWIRED_INTEGRATION : 'HARDWIRED_INTEGRATION',
    INTEGRATION_INTEGRATION_PROTOCOL : 'INTEGRATION_INTEGRATION_PROTOCOL',
    LIQUIDATED_DAMAGES_LIABILITY : 'LIQUIDATED_DAMAGES_LIABILITY',
    MINIMUM_CONDUIT_SIZE : 'MINIMUM_CONDUIT_SIZE',
    PENETRATION_REQUIREMENTS : 'PENETRATION_REQUIREMENTS',
    POWERTRUNK_LOCALPOWER : 'POWERTRUNK_LOCALPOWER',
    PROJECT_SCOPE : 'PROJECT_SCOPE',
    PROTOCOLS : 'PROTOCOLS',
    RESOURCE_REQUIREMENTS : 'RESOURCE_REQUIREMENTS',
    SIEMENS_CUSTOMER : 'SIEMENS_CUSTOMER',
    SIEMENS_OTHER_SUBCONTRACTOR : 'SIEMENS_OTHER_SUBCONTRACTOR', 
    TEMPORARY_SITE_PERSONNEL : 'TEMPORARY_SITE_PERSONNEL',
    WAIVER_REASON : 'WAIVER_REASON',
    REASON_FOR_EXCEPTION : 'REASON_FOR_EXCEPTION', //MS16
    MARGIN_EXCEPTION_AUTOMATION: 'MARGIN_EXCEPTION_AUTOMATION',
    MARGIN_EXCEPTION_SECURITY: 'MARGIN_EXCEPTION_SECURITY',
    MARGIN_EXCEPTION_FIRE: 'MARGIN_EXCEPTION_FIRE',
    MARGIN_EXCEPTION_MECHANICAL: 'MARGIN_EXCEPTION_MECHANICAL',
    MARGIN_EXCEPTION_ELECTRICAL: 'MARGIN_EXCEPTION_ELECTRICAL',
    YES_NO_UNKNOWN : 'YES_NO_UNKNOWN',
    COMMISSIONING_REQUIREMENTS : 'COMMISSIONING_REQUIREMENTS',
    CONSEQUENTIAL_DAMAGES_IN_CONTRACT : 'CONSEQUENTIAL_DAMAGES_IN_CONTRACT',
    CONSTRUCTION : 'CONSTRUCTION',
    CONTROLLER_TYPE : 'CONTROLLER_TYPE',
    CONTROL_VALVES_APPLICATIONS : 'CONTROLVALVES_APPLICATIONS',
    COOLING_TOWER_WIRING : 'COOLING_TOWER_WIRING',
    NETWORK_OPTIONS : 'NETWORK_OPTIONS',
    NETWORK_STYLE : "NETWORK_STYLE",
    FCU_INSTALLED_BY : "FCU_INSTALLED_BY",
    SALES_USE_NONE : "SALES_USE_NONE",
    ESTIMATE_DEPTH : "ESTIMATE_DEPTH",
    ETHERNET_MSTP: "ETHERNET_MSTP",
    AFMSS_APPLICATIONS : "AFMSS_APPLICATIONS",
    INSTALL_TYPE: "INSTALL_TYPE",
    SYSTEM_TYPE: "SYSTEM_TYPE",
    ADDITIONAL_SYSTEMS: "ADDITIONAL_SYSTEMS",
    ALPHA_NUMERIC_ANNUNCIATOR: "ALPHA_NUMERIC_ANNUNCIATOR",
    LED_ANNUNCIATOR: "LED_ANNUNCIATOR",
    FIRE_SMOKE_DAMPERS: "FIRE_SMOKE_DAMPERS",
    COMMUNICATION_METHOD: "COMMUNICATION_METHOD",
    CLASS_A_B_X: "CLASS_A_B_X",
    CLASS_A_B: "CLASS_A_B",
    BATTERY_BACKUP: "BATTERY_BACKUP",
    BACKUP_AMPS: "BACKUP_AMPS",
    DESIGO_PANELS: "DESIGO_PANELS",
    ELECTRICALWIRING_WIRING_TYPE : 'ELECTRICALWIRING_WIRINGTYPE',
    CONSUMABLES_INCLUDED : "CONSUMABLES_INCLUDED",
    SIEMENS_THIRD_PARTY: "SIEMENS_THIRD_PARTY",
    SYSTEM_INTERFACES: "SYSTEM_INTERFACES",
    COIL_CLEANING_INCLUDED_Value: "Condenser, Evaporater, H/C",
    ACCESS_CONTROL_SYSTEM_VENDOR: 'ACCESS_CONTROL_SYSTEM_VENDOR',
    CCTV_SYSTEM_VENDOR: 'CCTV_SYSTEM_VENDOR',
    INTRUSION_SYSTEM_VENDOR: 'INTRUSION_SYSTEM_VENDOR',
    MANAGEMENT_STATION: 'MANAGEMENT_STATION',
    NEGATIVE_TWO: -2,
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE : 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    ONE_THOUSAND: 1000,
    TECHNICAL_RISK_REVIEW_TRR:'Technical Risk Review (TRR)',
    MARGIN: 'Margin',
    ESCALATION: 'Escalation',
    ZTE_APPROVAL_REQUIRED: 'ZTE Approval Required',
    TASK_BASED_ESTIMATING: 'Task Based Estimating',
    SMorBGM : 'SM or BGM',
    BGM : 'BGM',
    ZOM: 'ZOM',
    ZONE_VP : 'Zone VP',
    NA : 'N/A',
    PERCENT: '%',
    DOLLAR: '$',
    REVIEW_APPROVED_MAIL_SUBJECT: 'Estimate Cost Review Approved',
    REVIEW_APPROVED_MAIL_BODY_LINE_1: 'The Cost Review for estimate ',
    REVIEW_APPROVED_MAIL_BODY_LINE_2: ' project is Approved.%0A%0A%0AGood Luck! %0A%0ACost Estimate Reviewer %0A',
    REVIEW_DENIED_MAIL_SUBJECT: 'Estimate Cost Review Denied',
    REVIEW_DENIED_MAIL_BODY_LINE_1: 'The Cost Review for estimate ',
    REVIEW_DENIED_MAIL_BODY_LINE_2: ' project is Denied.',
    REVIEW_DENIED_MAIL_BODY_LINE_3: '%0A%0A',
    REVIEW_DENIED_MAIL_BODY_LINE_4: '%0A%0APlease resubmit the request for review. %0A%0A%0ARegards, %0A%0ACost Estimate Reviewer %0A',
    REVIEW_MAIL_SUBJECT_HYPHEN: ' - ',
    LINE_FEED: '%0D%0A',
    AMPERCENT_FEED: '%26',
    OK: 'OK',
    CANCEL: 'CANCEL',
    APPROVED: 'Approved',
    DENIED : 'Denied',
    APPROVED_SUCCESSFULLY: 'Approved Successfully',
    DENIED_SUCCESSFULLY: 'Denied Successfully',
    OPEN : 'Open',
    STATUS : 'Status',
    MESSAGEBOX_COST_REVIEW_NO_ACCESS_ERROR: 'You do not have access to open this review.',
    MESSAGEBOX_NO_ACCESS_ERROR: 'You are not authorized to perform this action. Please contact your administrator.',
    MESSAGEBOX_COST_REVIEW_NO_ACCESS_TITLE: 'Access Denied!',
    MESSAGEBOX_APPROVE_DENY_ERROR_PREFIX: 'Si-Quote has detected a status change. ',
    MESSAGEBOX_APPROVE_DENY_ERROR_0: 'Server is not reachable please refresh and try again.',
    MESSAGEBOX_APPROVE_DENY_ERROR_2: 'The cost review was completed by {0}.',
    MESSAGEBOX_APPROVE_DENY_ERROR_MULTIPLE_REVIEWER_2: 'The cost review was completed.',
    MESSAGEBOX_APPROVE_DENY_ERROR_3: 'The cost review was reassigned to {0}.',
    MESSAGEBOX_APPROVE_DENY_ERROR_MULTIPLE_REVIEWER_3: 'The cost review was reassigned.',
    MESSAGEBOX_APPROVE_DENY_ERROR_4: 'The cost review was recalled by estimator.',
    MESSAGEBOX_APPROVE_DENY_HEADER: 'Review Status change',
    MESSAGEBOX_UNKNWON_ERROR_HEADER: 'Unknown Error',
    MESSAGEBOX_EXPORT_TO_CSV_HEADER: 'Export CSV Failed',
    COST_REVIEW_OPERATIONS_NETWORK_ERROR: 0,
    COST_REVIEW_OPERATIONS_ERROR_APPROVED_DENIED: 2,
    COST_REVIEW_OPERATIONS_ERROR_REASSIGNED: 3,
    COST_REVIEW_OPERATIONS_ERROR_RECALLED: 4,
    COST_REVIEW_OPERATIONS_NO_ACCESS: 401,
    UNAUTHORIZED_ERROR_CODE_401: 401,
    BAD_REQUEST_ERROR_CODE_400: 400,
    MT_TOKEN_KEY: 'mtTokenInfo',
    REMOVE_ROUTE_FROM_CACHE: 'removeRouteFromCache',
    USERS_ROUTE_KEY_FOR_CACHE: 'users',
    PROJECT_MANAGER: 'Project Manager',
    ENGINEER: 'Engineer',
    PROGRAMMING: 'Programming',
    GRAPHICS: 'Graphics',
    SPECIALIST: 'Specialist',
    DIGITAL_DEPLOYMENT_SPECIALIST: 'Digital Deployment Specialist',
    MECHANICAL: 'Mechanical',
    ELECTRICAL: 'Electrical',
    COST_LABOR_RISK: 'Risk',
    COST_LABOR_ENGINEER: 'Engineer',
    TOTAL: 'Total',
    POSITION_ID_18: '18',
    POSITION_ID_29: '29',
    POSITION_18: 18,
    POSITION_29: 29,
    ZERO_STR: '0',
    ENGINEERING_TDC: 'Engineering TDC',
    SM:'SM',
    ZERO_DECIMAL_PERCENT: '0.00%',
    ZERO_DECIMAL: '0.00',
    TWENTY: 20,
    EIGHTY: 80,
    FIRE: 'Fire',
    SECURITY: 'Security',
    AUTOMATION: 'Automation',
    AUTOMATION_FRCA : "Automatisation",
    ELECTRICAL_FRCA : "Électrique",
    ENERGY_FRCA : "Énergie",
    FIRE_FRCA : "Incendie",
    MECHANICAL_FRCA : "Mécanique",
    SECURITY_FRCA : "Sécurité",
    SPRINKLER_FRCA : "Extincteurs automatiques",
    ALLDISCIPLINE_FRCA : "Toutes les disciplines",
    TRILLION: 'Trillion',
    BILLION: 'Billion',
    MILLION: 'Million',
    THOUSAND: 'K',
    DIV: 'div',
    BOTTOM: 'bottom',
    MM_DD_YYYY: 'MM/dd/yyyy',
    ESTIMATE_ID_STORAGE_KEY: 'estimateIdFromQuerry',
    ESTIMATE_ID_QUERRY_KEY: 'estimateId',
    TRR_THRESHOLDS_STORAGE_KEY: 'trrThresholds',
    REVIEW_ROUTE: 'dashboard/review',
    REVIEW_DETAILS_ROUTE: 'dashboard/review/details',
    ESTIMTATES_ROUTE: 'dashboard/estimates',
    USERS_ROUTE: 'dashboard/users',
    LOGIN_ROUTE: '/login',
    FILTER_DATA: 'SectionAdjustedHour',
    EMPTY_STRING: '',
    DOUBLE_EMPTY_SPACE: ' ',
    TASK_BY_LEVEL_SUMMARY_LABEL: 'Summary',
    TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL:'Estimate Level',
    TASK_BY_LEVEL_SUMMARY_LABEL_FR: 'Sommaire',
    TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL_FR:'Niveau d\'estimation',
    TASK_BY_LEVEL_HOURS_TOTAL_LABEL: 'Hours Total',
    ONE_LAKH_FIFTY_THOUSAND: 150000,
    PROJECT_CATEGORY_W: 'W',
    PROJECT_CATEGORY_T: 'T',
    PROJECT_CATEGORY_S: 'S',
    BUSINESS_FIRE: 'F',
    BUSINESS_SECURITY: 'S',
    BUSINESS_AUTOMATION: 'A',
    BUSINESS_ELECTRICAL: 'E',
    BUSINESS_MECHANICAL: 'M',
    AUTOMATION_SERVICE_PROJECT_US: 3,
    MECHANICAL_SERVICE_PROJECT_US: 8,
    //for en_can
    AUTOMATION_SERVICE_PROJECT_CN_EN: 11,
    AUTOMATION_SERVICE_PROJECT_CN_FR: 19,
    //for fn_can
    MECHANICAL_SERVICE_PROJECT_CN_EN: 16,
    MECHANICAL_SERVICE_PROJECT_CN_FR: 24,
    ONE_STR:'1',
    TWO_STR:'2',
    MIN_ACCESS_LEVEL_FOR_USERS_TAB: 2,
    MIN_ACCESS_LEVEL_FOR_REPORTS_TAB: 2,
    UNSUPPORTED_ACCESS_LEVEL: 5,
    UNAUTHORIZED_MT_USER_MESSAGE: 'You are not authorized to use this tool. Please contact the Si-Quote team for further assistance.',
    BAD_REQUEST_MT_USER_MESSAGE: 'Microsoft Authentication failed. Please contact the Si-Quote team for further assistance.',
    UNAUTHORIZED_MT_USER_TITLE: 'Si-Quote Manager Tool',
    DATE_FORMAT_FOR_REPORTS: 'dd-MMM-yy',
    HEADER_FOR_MANAGERS: {user: 'Manager',  id: 'ID',country: 'Country',homeZone: 'Home Zone',email: 'Email',status: 'Status'},
    HEADER_FOR_USERS: {user: 'User',  id: 'ID',country: 'Country',homeZone: 'Home Zone',email: 'Email',status: 'Status'},
    HEADER_FOR_USERS_WITH_USER_TYPE: {user: 'User Name',  id: 'ID',userType: 'User Type',country: 'Country',homeZone: 'Home Zone',email: 'Email',status: 'Status'},
    HEADER_FOR_UNKNOWN_USERS: {id: 'Unknown User ID'},
    HEADER_USER_ACTIVITY_REPORT: {user: 'User',  id: 'ID',country: 'Country',year: 'Year',month: 'Month',estimates: '# oF Estimates'},
    HEADER_LOCAL_ACTIVITY_SUMMARY: {country: 'Locale',year: 'Year',month: 'Month',estimates: '# oF Estimates'},
    PRINTCONTENT_FOR_REPORTS : '<table border="1" style="width:100%; border-collapse:collapse;">',
    PRINTCONTENT_FOR_REPORTS_HEADER : '</tr></thead><tbody>',
    PRINTCONTENT_FOR_REPORTS_TABLE_END : '</tbody></table>',
    PRINTCONTENT_FOR_REPORTS_HEADING: '<html><head><title>Print Report</title></head><body>',
    PRINTCONTENT_FOR_REPORTS_FOOTER: '</body></html>',
    OPEN_NEW_TAB: '_blank',
    DEFAULT_PAGE_SIZE: 32,
    ACTIVE_MANAGERS_KEY: 0,
    ACTIVE_USERS_KEY: 1,
    INACTIVITY_MANAGERS_KEY: 2,
    INACTIVE_USERS_KEY: 3,
    UNKNOWNUSERS_KEY: 4,
    USER_STATUS_KEY: 5,
    USER_DETAIL_ACTIVITY_KEY: 6,
    LOCAL_ACTIVITY_SUMMARY_KEY: 7,
    DATA_NOT_FOUND_REPORTS: 'The requested data could not be fetched. Please try again later or contact support if the issue persists.',
    DIALOG_TITLE_REPORTS: 'No Data Found',
    DIALOG_TITLE_API_ERROR: 'Error',
    API_ERROR_REPORTS: 'An isssue occured while fetching the data. Please contact $i-Quote Team.',
    API_ERROR_REPORTS_TITLE: 'Error',
    NO_DATA_FOUND: 'No Data Found',
    API_ERROR:'API Error',
    NOT_A_USER_IN_TOOL : " is not a user in the tool.  Please check the address and try again",
    USER_REMOVED_FROM_TOOL : " is removed from the tool.  Please check the address and try again",
    USER_HAS_NO_ACCESS_TO_TOOL : " has no access to the tool.  Please check the address and try again",
    USER_NOT_VALID_FOR_DELEGATION_NOT_COST_REVIEWER : " is not a cost reviewer.  Please check the address and try again",
    USER_NOT_VALID_FOR_COST_REVIEW_DELEGATION : " has already delegated the cost reviews to you. Please delegate to some other user.",
    USER_CANNOT_DELEGATE_TO_SELF : "You cannot delegate cost review to yourself. Please delegate to some other user.",
    USER_NOT_FOUND : "User not found",
    DELEGATE_DIALOG_TITLE : "Si-Quote Manager Tool",
    NOT_A_USER_IN_TOOL_CASE : 1,
    USER_REMOVED_FROM_TOOL_CASE : 2,
    USER_HAS_NO_ACCESS_TO_TOOL_CASE : 3,
    USER_NOT_VALID_FOR_DELEGATION_NOT_COST_REVIEWER_CASE : 4,
    USER_NOT_VALID_FOR_COST_REVIEW_DELEGATION_CASE : 5,
    USER_CANNOT_DELEGATE_TO_SELF_CASE : 6,
    USER_LINKING_CONFIRMATION_MESSAGE: 'Are you sure? This will add New User Id in database',
    MANAGER_PRIVILEGES_DELEGATED_SUCCESSFULLY: ' Manager Privileges Delegated Successfully',
    TOASTER_TITLE_FOR_DELEGATE_MANAGER_PRIVILEGES: 'Manager Privileges',
    TOASTER_TITLE_FOR_USER_LINKING: 'User Linking',
    MANAGER_PRIVILEGES_DELEGATED_UNSUCCESSFULLY_MESSAGE: ' is not found in the Siemens active directory. Please check the address and try again.',
    WARNING: 'Warning',
    USER_LINKING_SUCCESSFUL :'User linking is successful',
    USER_LINKING_FAILED :'User linking failed. Please try again later.',
    USER_LINKING_EXISTS: 'Already added userId in database.',
    NO_DELEGATION_FOUND: 'No delegation found',
    MANAGER_PRIVILEGES_REMOVED_SUCCESSFULLY: 'Manager Privileges Removed Successfully',
    USER_STATUSCODE_FOR_DELEGATION: 0,
    ALL_OPTION: '- All -',
    TWO_THOUSAND_SEVEN: 2007,
    SUCCESS: 'Success',
    FAILED: 'Failed',
    SNAP_ERROR: "Ohh Snap!",
    MASTER_DATA_FAILURE_MSG: "Failed to fetch the data. Please try again.",
    ASSIGN_NEW_OWNER_SUCCESS_MSG: 'New owner assigned successfully.',
    ASSIGN_NEW_OWNER_FAILED_MSG: 'New owner assignment failed. Please try again.',
    ESTIMATES: 'Estimates',
    NA_WITHOUT_SLASH: 'NA',
    AUTO_EMAIL_NOTIFICATION: 'Auto Email Notification',
    AUTO_EMAIL_NOTIFICATION_FAILED: 'Auto Email Notification preference set failed. Please try again!',
    RELEASE_EDIT_ACCESS: 'Release Edit Access',
    RELEASE_EDIT_ACCESS_SUCCESS_MSG: 'Release Edit Access request submitted successfully.',
    RELEASE_EDIT_ACCESS_FAILED_MSG: 'Release Edit Access request submission failed. Please try again later.',
    SEARCH_ESTIMATES_FAILED: 'Search Estimates failed. Try again!',
    LOAD_ESTIMATES_HEADER_MASTER_DATA_FAILED: 'Failed to load master data for estimates. Try refreshing the page!',
    COMMA: ',',
    ALL_DATES: 'All Dates',
    DOUBLE_ZERO: '00',
    HUNDRED: 100,
    ERROR_CODE_204: 204,
    ERROR_CODE_500: 500,
    ERROR_CODE_409: 409,
    ERROR_CODE_401: 401,
    Ten:10,
    PREFERENCES: "Preferences",
    PREFERENCE_UPDATE_SUCCESS:"User preferences updated successfully.",
    REVIEW_DETAILS_TITLE : 'Review Details',
    REVIEW_DETAILS_NAVIGATION_FAILURE_MSG : 'No review is selected.',
    ALL_MONTHS_ARRAY: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    All_MONTHS_JSON: [
        { id: 1, name: "Jan" },
        { id: 2, name: "Feb" },
        { id: 3, name: "Mar" },
        { id: 4, name: "Apr" },
        { id: 5, name: "May" },
        { id: 6, name: "Jun" },
        { id: 7, name: "Jul" },
        { id: 8, name: "Aug" },
        { id: 9, name: "Sep" },
        { id: 10, name: "Oct" },
        { id: 11, name: "Nov" },
        { id: 12, name: "Dec" },
    ],
    DATE_MODIFIED: 'Date Modified',
    DATE_CREATED: 'Date Created',
    BEFORE: 'Before',
    AFTER: 'After',
    DURING: 'During',
    COPY_ROWS: 'Copy Rows',
    NO_DATA_TO_COPY: 'No data to copy.',
    ESTIMATE_ROWS_COPY_SUCCESS_MSG: 'Estimate rows copied to clipboard.',
    MANAGER_PRIVILEGES_DELEGATED_UNSUCCESSFULLY_MESSAGE_FROM_SERVER: 'Internal Server Error. Please try again later.',
    SOL_DIFFICULTY_LEVEL_SIMPLE:'1',
    SOL_DIFFICULTY_LEVEL_STANDARD:'2',
    SOL_DIFFICULTY_LEVEL_COMPLEX:'3',
    ADD_TAB: '\u00A0\u00A0\u00A0\u00A0',
    NEGATIVE_INFINITE: '-99999.00',   
    SIM_HOURS_AND_TASK_DIFFICULTY_LEVEL:'Simple',
    MED_HOURS_AND_TASK_DIFFICULTY_LEVEL:'Standard',
    COM_HOURS_AND_TASK_DIFFICULTY_LEVEL:'Complex',
    SUMMARY: 'Summary',
    MINUS_ONE: -1,
    EXISTING_USER_MESSAGE: 'is an existing user in the Manager Tool. The user is shown below',
    USER_NOT_FOUND_MESSAGE: 'is not found in the Siemens active directory. Please check the address and try again',
    FAILED_TO_FETCH_USER_DETAILS: 'Failed to fetch user details. Please try again later.',
    USER_DIALOG_TITLE: 'Si-Quote Manager Tool',
    USER_CONFIRMATION_MESSAGE: 'Do you want to save the changes ?',
    TWENTY_FIVE_THOUSAND: 25000,
    HYPHEN: '-',
    ALL_DISCIPLINES: 'All Disciplines',
    ENERGY: 'Energy',
    SPRINKLER: 'Sprinkler',
    DEFAULT_DATE: '01/01/0001',
    EMPTY_DATE: '01/01/1970',
    MAX_MAILTO_URL_LENGTH: 1649,
    LABOR_BY_LEVEL_TOTALS_LABEL: 'Totals',
    SESSION_EXPIRED_MESSAGE: 'Session Expired !! Please login again.',
    SESSION_EXPIRED_TITLE: 'Session Expired',
    DEFAULT_VALUE_FOR_HOURS_TASKS: '00000000-0000-0000-0000-000000000000',
    ZERO_HOURS: 0.0,
    DEFAULT_VALUE_WITH_DOLLAR: '$0.00',
    COST_REVIEW: "Cost Review",
    MASTERDATA_ERROR_MESSAGE: "Error while fetching master data. Please refresh the page.",
    ERROR_OPENING_REVIEW_FROM_LINK: "Error while opening the review from link! Please contact Si-Quote team.",
    ONE_MILLION: 1000000,
    SOL_DIFFICULTY_LEVEL_NONE:'0.00',
    NONE_HOURS_AND_TASK_DIFFICULTY_LEVEL: 'None',
    NONE: 'None',
    ANALYTIC_SERVICES: 'Analytic Services',
    FIFTY: 50,
    NOTES: 'Notes',
    TEN: 10,
    UNDERSCORE: '_',
    REVIEW_ROUTE_CHECK: 'review',
    FIVE_MINUTES_IN_MILISECONDS: 300000,
    REVIEW_SYNC_TITLE: 'Review Sync',
    REVIEW_SYNC_PAUSE_MESSAGE: 'Review Sync Paused',
    REVIEW_SYNC_RESUME_MESSAGE: 'Review Sync Resumed',
    SA_COSTS_AND_LABORS: 'Costs & Labors',
    SA_EQUIPMENTS: 'Equipments',
    SA_MARGINS: 'Margins',
    SA_SERVICES: 'Services',
    SA_SUMMARY: 'Summary',
    SA_SITE_QUALIFICATION: 'Site Qualification',
    SA_PROVEN_OUTCOMES: 'Proven Outcomes',
    SA_RISKS: 'Risks',
    SA_TOOL: 'Tools',
    SA_POLICY_EXCEPTIONS: 'Policy Exceptions',
    SA_SCOPE: 'Scope',
    SA_SAP_MATERIAL_NUMBER: 'SAP Numbers',
    SOL_BID_DOCUMENTATION: 'Bid Documentation',
    SOL_CONDITIONS: 'Conditions',
    SOL_CONTRACTUAL_DOCUMENTATION:'Contractual Documentation',
    SOL_LABOR_AND_COSTS:'Labor & Costs',
    SOL_HOURS_TASKS:'Hours/Tasks',
    SOL_MARGINS:'Margins',
    SOL_SUMMARY:'Summary',
    SOL_MATERIAL: 'Material',
    SOL_OVERTIME: 'OT/PWR',
    SOL_PM_REQUIREMENTS: 'PM Requirements',
    SOL_RISK: 'Risk',
    SOL_POLICY_EXCEPTIONS: 'Policy Exceptions',
    SOL_SUBS_AND_MISC: 'Subs & Misc',
    SIXTY: 60,
    DEFAULT_LOCALE: 'en-US',
    GREEN_COLOR: '#009999',
    ONE_TWENTY: 120,
    ELEVEN: 11,
    NINE: 9,
    THIRTY: 30,
    THIRTY_FIVE: 35,
    FORTY_SEVEN: 47,
    SIXTY_SEVEN: 67,
    TWELVE: 12,
    TWENTY_FIVE: 25,
    TWENTY_FOUR: 24,
    FOURTEEN: 14,
    EIGHT: 8,
    ONE_FIFTY: 150,
    ONE_FIFTY_THREE: 153,
    TWO_FIFTY_FIVE: 255,
    ZERO_POINT_ONE: 0.1,
    ZERO_POINT_SEVEN: 0.7,
    SIXTY_FOUR: 64,
    ONE_TWENTY_EIGHT: 128,
    LEVEL_DESCRIPTION: 'levelDescription',
    DEFAULT_DECIMAL_PRECISION: 2,
    LANGUAGE_EN_US: 'en-US',
    LANGUAGE_FR_CA: 'fr-CA',
    DOT: '.',
    LANGUAGE_EN_CA: 'en-CA',
    SIEMENS_THIRDPARTY_CUSTOMER: 'SIEMENS_THIRDPARTY_CUSTOMER',
    SPECIAL_EQUIPMENT: 'SPECIAL_EQUIPMENT',
    MAX_JOB_DETAILS_NUMERIC_VALUE: 999999999
}